import React from 'react';
import { Line } from 'react-chartjs-2';
import 'chart.js/auto';

const RevenusGraphique = ({ statistics }) => {
    // Transformer les données pour les afficher dans le graphique
    const revenusData = statistics.total_ttc_par_mois_sur_annee.map(item => ({
        month: item.month,
        year: item.year,
        totalTTC: item.total_ttc,
    }));

    // Labels pour les mois (exemple : Jan, Feb, ...)
    const monthLabels = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const chartData = {
        labels: revenusData.map(item => `${monthLabels[item.month - 1]} ${item.year}`),
        datasets: [
            {
                label: 'Revenus encaissés (TTC)',
                data: revenusData.map(item => item.totalTTC),
                backgroundColor: 'rgba(0, 0, 143, 0.2)', // Remplissage en AXA Blue avec opacité (40%)
                borderColor: '#D24723', // Ligne en AXA Sienna
                pointBorderColor: '#D24723', // Bordure des points en AXA Sienna
                pointBackgroundColor: '#D24723', // Points en AXA Sienna
                pointRadius: 5,  // Taille des points
                pointHoverRadius: 8,  // Taille des points au survol
                fill: true,  // Remplir la zone sous la courbe
                tension: 0.4,  // Adoucir la courbe
                showLine: true,  // Montrer la ligne dans le graphique
            },
        ],
    };

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    color: '#00000F', // AXA Blue pour les labels Y
                    font: {
                        size: 14,
                        weight: 'bold',
                    },
                },
                title: {
                    display: true,
                    text: 'Revenus TTC',
                    color: '#00008F', // AXA Sienna pour le titre Y
                    font: {
                        size: 16,
                        weight: 'bold',
                    },
                },
            },
            x: {
                ticks: {
                    color: '#00000F', // AXA Blue pour les labels X
                    font: {
                        size: 14,
                        weight: 'bold',
                    },
                },
                title: {
                    display: true,
                    text: 'Mois',
                    color: '#00008F', // AXA Sienna pour le titre X
                    font: {
                        size: 16,
                        weight: 'bold',
                    },
                },
            },
        },
        plugins: {
            legend: {
                display: true,
                labels: {
                    usePointStyle: true,
                    pointStyle: 'circle',
                    color: '#00008F', // AXA Blue pour les légendes
                    font: {
                        size: 14,
                        weight: 'bold',
                    },
                },
            },
        },
    };


    return (
        <div className="bg-white p-8 rounded-lg shadow-lg">
            <h2 className="text-2xl font-bold mb-6 text-center text-axa-blue-400">
                Revenus encaissés sur les 365 derniers jours
            </h2>
            <div className="relative w-full h-96">
                <Line data={chartData} options={chartOptions} />
            </div>
        </div>
    );
};

export default RevenusGraphique;